/**
 * @file XCOMM Identity related fragments.
 */

import gql from 'graphql-tag';

import { PhotoThumbnails } from '../../../../graphql/fragments/album';
import { SelectedIdentityAlbumFolderTagDetailsForMatching } from './album-folder-tags';

export const IdentityCommandBasicDetails = gql`
  fragment IdentityCommandBasicDetails on Identity {
    id
    relationship
    name
    last_name
    account {
      id
    }
  }
`;

export const IdentitySelfieDetails = gql`
  fragment IdentitySelfieDetails on IdentitySelfie {
    id
    is_avatar
    matching_enabled
    selfie_type
    selfie_source
    created_at
    photo {
      ...PhotoThumbnails
    }
    face {
      facebox
    }
  }
  ${PhotoThumbnails}
`;

export const IdentityMatchingDetails = gql`
  fragment IdentityMatchingDetails on Identity {
    ...IdentityCommandBasicDetails
    current_matching_face {
      id
      facebox
      photo {
        ...PhotoThumbnails
      }
    }
    selfies(slice: { limit: 999 }) {
      records {
        ...IdentitySelfieDetails
      }
    }
    album_folder_tags {
      records {
        ...SelectedIdentityAlbumFolderTagDetailsForMatching
      }
    }
  }
  ${IdentityCommandBasicDetails}
  ${PhotoThumbnails}
  ${IdentitySelfieDetails}
  ${SelectedIdentityAlbumFolderTagDetailsForMatching}
`;
